import i18n from "@/i18n";
import { nextTick } from "vue";
import { langMap } from "../util/dataProvider";

const TransLation = {
  async loadLocaleMessages(locale) {
    if (!i18n.global.availableLocales.includes(locale)) {
      const messages = await import(`./locales/${langMap[locale]}.json`);
      i18n.global.setLocaleMessage(locale, messages.default);
    }
    return nextTick();
  },

  getUserLocale() {
    const locale = i18n.global.locale.value;
    return {
      locale: locale,
      localeNoRegion: locale.split("-")[0],
    };
  },
};

export default TransLation;
